import { teams } from '../types'
import { toast as sendToast } from '../types';

export const setOpenedTeamTab = ({ openedTab }) => ({
    type: teams.SET_OPENED_TAB,
    payload: { openedTab }
})


export const showAddTeams = ({ isShowAddTeam, teamsMainDiv, isShowUserDetails }) => ({ type: teams.IS_SHOW_ADD_TEAM, payload: { isShowAddTeam, teamsMainDiv, isShowUserDetails } })


export const sendErrorToastTeam = ({ status, message }) => ({
    type: sendToast.SEND_TOAST,
    payload: { status, message }
})


export const getTeamList = ({ org, message, concat, page, limit, sort_by, query, dropdown, give_actions }) => ({
    type: teams.GET_TEAMS_LIST_REQUEST,
    payload: { org, message, concat, page, limit, sort_by, query, dropdown, give_actions }
})

export const deleteTeamAction = ({ teamId, teamName, formName }) => ({
    type: teams.DELETE_TEAM_REQUEST,
    payload: { teamId, teamName, formName },
});

export const editTeam = ({ teamId, name, formName }) => ({
    type: teams.EDIT_TEAM_REQUEST,
    payload: { teamId, name, formName },
});

export const generateInviteLinkTeam = ({ teamId, invitationTo }) => ({
    type: teams.GENERATE_INVITE_LINK_TEAM_REQUEST,
    payload: { teamId, invitationTo }
})

export const addUsersInTeam = ({ users, teamId, formName, teamName, navigate, redirectTo, addedMembers, source, projectId }) => ({
    type: teams.ADD_USERS_TEAM_REQUEST,
    payload: { users, teamId, formName, teamName, navigate, redirectTo, addedMembers, source, projectId },
});

export const addUsersInTeamaByInvitation = ({ inviteId, navigate }) => ({
    type: teams.ADD_USERS_IN_TEAMS_BY_INVITATION_REQUEST,
    payload: { inviteId, navigate },
});


export const removeUserFromTeam = ({ teamId, userName, teamName, members, formName, source, projectId }) => ({
    type: teams.REMOVE_TEAM_AGENT_REQUEST,
    payload: { teamId, userName, teamName, members, formName, source, projectId },
});


export const getTeamUsersList = ({ org_id, query, limit, page, mobile, email, is_possible_remote_support }) => ({
    type: teams.GET_TEAM_USERS_LIST_REQUEST,
    payload: { org_id, query, limit, page, mobile, email, is_possible_remote_support }
});


export const createNewTeam = ({ data, formName, callOnSuccess = () => { } }) => ({
    type: teams.CREATE_NEW_TEAM_REQUEST,
    payload: { data, formName, callOnSuccess },
});

export const linkProject = ({ teamId, project_ids, formName }) => ({
    type: teams.LINK_PROJECT_REQUEST,
    payload: { teamId, project_ids, formName },
});

export const unlinkProject = ({ teamId, project_ids, formName }) => ({
    type: teams.UNLINK_PROJECT_REQUEST,
    payload: { teamId, project_ids, formName },
});

export const getLinkedProjects = ({ teamId }) => ({
    type: teams.GET_LINKED_PROJECTS_REQUEST,
    payload: { teamId },
});






export const getTeamsDropDownList = ({ org_id, query, page, limit }) => ({
    type: teams.GET_TEAMS_DROPDOWN_LIST_REQUEST,
    payload: { org_id, query, page, limit }
})


export const getTeamsUserList = ({ teamId }) => ({
    type: teams.GET_TEAMS_USERS_LIST_REQUEST,
    payload: { teamId }
})